<template>
  <div>
    <div class="blockUI blockOverlay" />
    <div class="blockUI blockMsg blockElement">
      <i class="icon-spinner9 spinner" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WidgetLoader',
  }
</script>

<style scoped>
  .blockUI.blockOverlay {
    z-index: 990;
    border: none;
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background-color: rgb(255, 255, 255);
    opacity: 0.8;
    cursor: wait;
    position: absolute;
  }

  .blockUI.blockMsg.blockElement {
    z-index: 1011;
    position: absolute;
    padding: 0px;
    margin: 0px;
    width: 16px;
    height: 20px;
    top: calc(50% - 10px);
    left: calc(50% - 8px);
    text-align: center;
    color: rgb(0, 0, 0);
    border: 0px;
    cursor: wait;
  }
</style>
